@if (form) {
    <div class="w-full max-w-5xl p-8">
        <div class="prose prose-sm !max-w-100 col-span-4 mb-[20px]">
            <h2>Senda auðkenningarbeiðni</h2>
            <p>Hér getur þú sent viðkomandi auðkenningarbeiðni og þannig staðfest deili á honum/henni</p>
        </div>
        <span class="separator-line block mb-[30px]"></span>
        <form [formGroup]="form" #profileInNgForm="ngForm">
            <div class="w-full">
                <ng-container>
                    <mat-tab-group
                        class="px-2 hjalp-tab-group sign-in-tab-group fade-in-left"
                        [animationDuration]="'0'"
                        [(selectedIndex)]="selectedPanelIndex"
                        (selectedTabChange)="tabChanged($event)"
                    >
                        <mat-tab [label]="'Rafræn skilríki (SIM)'">
                            <div class="grid sm:grid-cols-4 gap-6 mt-2">
                                <div class="col-span-4 sm:col-span-2">
                                    <mat-form-field class="fuse-mat-no-subscript w-full">
                                        <mat-label>Símanúmer</mat-label>
                                        <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:phone_iphone'" matPrefix></mat-icon>
                                        <input (keyup)="phoneKeyUp($event)" [formControlName]="'phone'" matInput />
                                    </mat-form-field>
                                </div>
                                <ng-container *ngTemplateOutlet="message"></ng-container>
                                <ng-container *ngTemplateOutlet="messageAddition"></ng-container>
                            </div>
                        </mat-tab>
                        <mat-tab [label]="'Auðkennisapp'">
                            <div class="grid sm:grid-cols-4 gap-6 mt-2">
                                <div class="col-span-4 sm:col-span-2">
                                    <mat-form-field class="fuse-mat-no-subscript w-full">
                                        <mat-label>Kennitala</mat-label>
                                        <mat-icon class="icon-size-5" [svgIcon]="'mat_outline:assignment_ind'" matPrefix></mat-icon>
                                        <input (keyup)="socialSecurityNumberKeyUp($event)" [formControlName]="'ssn'" matInput />
                                    </mat-form-field>
                                </div>
                                <ng-container *ngTemplateOutlet="message"></ng-container>
                                <ng-container *ngTemplateOutlet="messageAddition"></ng-container>
                            </div>
                        </mat-tab>
                    </mat-tab-group>
                    <ng-template #message>
                        <div class="col-span-4 sm:col-span-2">
                            <mat-form-field class="fuse-mat-no-subscript w-full">
                                <mat-label>Skilaboð vegna auðkenningar</mat-label>
                                <input [formControlName]="'skilabod'" matInput />
                            </mat-form-field>
                        </div>
                    </ng-template>
                    <ng-template #messageAddition>
                        <div class="col-span-4">
                            <mat-form-field class="w-100">
                                <mat-label>Viðbótarupplýsingar</mat-label>
                                <textarea
                                    class="text-area"
                                    maxlength="200"
                                    matInput
                                    formControlName="vidbotarupplysingar"
                                    placeholder="Hér getur þú tilgreint viðbótarupplýsingar sem verða skráðar með auðkenningarbeiðninni"
                                ></textarea>
                                <mat-hint class="ml-auto"
                                    ><span
                                        class="bold"
                                        [ngClass]="{
                                            'notification-color': this.form?.get('vidbotarupplysingar')?.value?.length > 190,
                                        }"
                                        >{{ 200 - this.form?.get('vidbotarupplysingar')?.value?.length }}</span
                                    >
                                    stafir eftir</mat-hint
                                >
                            </mat-form-field>
                        </div>
                    </ng-template>
                </ng-container>
            </div>
            <div class="flex items-center justify-end mt-[20px] p-8">
                @if (form.dirty) {
                    <button mat-stroked-button type="button" (click)="revertAllChanges()" [disabled]="!formEnabled">
                        {{ 'label_cancel' | translate }}
                    </button>
                }
                <button class="ml-4" (click)="save()" mat-flat-button type="submit" [color]="'primary'" [disabled]="!formEnabled">
                    @if (formEnabled) {
                        <span> Senda auðkenningarbeiðni </span>
                    }
                    @if (!formEnabled) {
                        <mat-progress-spinner [diameter]="24" [mode]="'indeterminate'"> </mat-progress-spinner>
                    }
                </button>
            </div>
        </form>
        @if (!form.dirty && publicAuthRequestUser != null) {
            <div class="flex flex-wrap fade-in-left">
                <div class="grid sm:grid-cols-4 gap-6 w-full mt-8">
                    <div class="relative col-span-4 p-6 pr-3 pb-3 bg-card rounded-2xl shadow overflow-hidden">
                        <div class="absolute bottom-0 right-0 w-24 h-24 -m-6">
                            <mat-icon class="icon-size-24 opacity-25 text-primary-500" svgIcon="heroicons_solid:shield-check"> </mat-icon>
                        </div>
                        <div class="flex flex-col items-center mt-2">
                            <div class="text-7xl sm:text-8xl font-bold tracking-tight leading-none text-blue-500">
                                {{ publicAuthRequestUser.name }}
                            </div>
                            <div class="text-lg font-medium text-blue-600 dark:text-blue-500">
                                kt. {{ formatSsn(publicAuthRequestUser.ssn) }}
                            </div>
                            <div class="flex items-baseline justify-center w-full mt-5 text-secondary">
                                <div class="text-md font-medium truncate">
                                    Auðkenni staðfest þann
                                    {{ formatDate(publicAuthRequestUser.timeStamp) }}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        }
    </div>
}
